function pickFirst(...values) {
  return values.find((value) => value !== undefined && value !== null && String(value).trim() !== '');
}

function normalizeList(value) {
  if (Array.isArray(value)) {
    return value;
  }

  if (value && typeof value === 'object') {
    return Object.values(value);
  }

  return [];
}

function normalizePartnershipPayload(payload) {
  if (payload?.partnership && typeof payload.partnership === 'object') {
    return payload.partnership;
  }

  if (payload?.data?.partnership && typeof payload.data.partnership === 'object') {
    return payload.data.partnership;
  }

  if (payload && typeof payload === 'object') {
    return payload;
  }

  return null;
}

function buildPersonName(person) {
  if (!person || typeof person !== 'object') {
    return '-';
  }

  const firstName = pickFirst(person.firstName, person.first_name);
  const lastName = pickFirst(person.lastName, person.last_name);
  const fullName = [firstName, lastName].filter(Boolean).join(' ').trim();

  return fullName || pickFirst(person.name, person.full_name, person.username, person.emailMasked, person.email_masked) || '-';
}

function mapPartnerPerson(person) {
  if (!person || typeof person !== 'object') {
    return null;
  }

  const profile = person.profile && typeof person.profile === 'object' ? person.profile : person;

  return {
    uid: String(pickFirst(person.partnerUid, person.partner_uid, person.uid, person.id, profile.uid, profile.id) || '').trim(),
    name: buildPersonName(profile),
    email: pickFirst(profile.emailMasked, profile.email_masked, person.email) || '-',
    display: pickFirst(person.display) || `${buildPersonName(profile)} <${pickFirst(profile.emailMasked, profile.email_masked, person.email) || '-'}>`,
  };
}

function mapHistoryPartnerRow(row, index) {
  const partner = mapPartnerPerson(row);

  return {
    key: String(pickFirst(row?.partnerUid, row?.partner_uid, row?.uid, row?.id, `partner-${index}`)),
    uid: String(pickFirst(row?.partnerUid, row?.partner_uid, row?.uid, row?.id) || '').trim(),
    name: partner?.name || '-',
    email: partner?.email || '-',
    lastSeenAt: pickFirst(
      row?.lastSeenAt,
      row?.last_seen_at,
      row?.lastActivityAt,
      row?.last_activity_at,
      row?.seenAt,
      row?.seen_at,
    ) || '',
  };
}

function mapCurrentPartner(row) {
  const partner = pickFirst(
    row?.currentPartner,
    row?.current_partner,
    row?.partner,
    row?.currentAttribution,
    row?.current_attribution,
    row?.currentPartnerInfo,
    row?.current_partner_info,
  );

  const normalizedPartner = mapPartnerPerson(partner);
  if (!normalizedPartner) {
    return null;
  }

  return {
    ...normalizedPartner,
    display: pickFirst(partner?.display) || `${normalizedPartner.name} <${normalizedPartner.email}>`,
  };
}

function mapAccountRow(row, index) {
  return {
    key: String(pickFirst(row?.accountUid, row?.account_uid, row?.uid, row?.id, row?.login, `account-${index}`)),
    uid: String(pickFirst(row?.accountUid, row?.account_uid, row?.uid, row?.id) || '').trim(),
    login: pickFirst(row?.login, row?.accountLogin, row?.account_login) || '-',
    type: pickFirst(row?.type, row?.accountType, row?.account_type) || '-',
    platform: pickFirst(row?.platform, row?.platformName, row?.platform_name) || '-',
    currency: pickFirst(row?.currency, row?.currencyCode, row?.currency_code) || '-',
    currentPartner: mapCurrentPartner(row),
  };
}

export function mapPartnershipResponseToDto(payload) {
  const partnership = normalizePartnershipPayload(payload);
  if (!partnership) {
    return {
      historyPartners: [],
      accounts: [],
    };
  }

  return {
    historyPartners: normalizeList(partnership.historyPartners || partnership.history_partners || partnership.partners).map(mapHistoryPartnerRow),
    accounts: normalizeList(partnership.accounts || partnership.clientAccounts || partnership.client_accounts).map(mapAccountRow),
  };
}
